import React, { memo } from 'react';
import { FileTextIcon, HeartIcon, BrainIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const CoreSolutions = () => {
  return <section className="my-12" data-id="element-2275">
      <h2 className="text-2xl font-serif font-bold text-slate-900 mt-10 mb-5 leading-tight border-b border-slate-200 pb-2 flex items-center" data-id="element-2276">
        <FileTextIcon className="h-5 w-5 text-slate-700 mr-2 inline" data-id="element-2277" />
        Evidence-Based Solutions for Women's Health Challenges
      </h2>
      <p className="text-base text-slate-800 leading-relaxed mb-8" data-id="element-2278">
        Our clinically-validated approaches target the most common and
        disruptive women's health issues. Each solution is backed by rigorous
        research and real-world testing with thousands of women.
      </p>
      <div className="space-y-8 mt-8" data-id="element-2279">
        {/* Vaginal Health Solution */}
        <div className="bg-white p-6 border-l-4 border-rose-500 shadow-sm" data-id="element-2280">
          <div className="flex items-start" data-id="element-2281">
            <div className="h-6 w-6 text-rose-500 mr-4 mt-1 flex-shrink-0" data-id="element-2282" />
            <div data-id="element-2283">
              <h3 className="text-xl font-serif font-semibold text-slate-900 mb-3" data-id="element-2284">
                Revolutionary Protocol for Recurring Bacterial Vaginosis
              </h3>
              <p className="text-base text-slate-700 leading-relaxed mb-4" data-id="element-2285">
                Our breakthrough biofilm-disruption technology addresses the
                root cause of recurring BV and vaginal odor that 73% of women
                never find lasting relief from with conventional treatments.
              </p>
              <div className="bg-rose-50 p-4 rounded" data-id="element-2286">
                <p className="text-slate-800 font-medium" data-id="element-2287">Clinical Results:</p>
                <ul className="mt-2 space-y-2" data-id="element-2288">
                  <li className="flex items-start" data-id="element-2289">
                    <span className="text-rose-600 font-semibold mr-2" data-id="element-2290">•</span>
                    <span className="bg-yellow-100 px-1" data-id="element-2291">
                      <span className="font-semibold" data-id="element-2292">87%</span> of women
                      experienced reduced odor and discharge within 7 days
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-2293">
                    <span className="text-rose-600 font-semibold mr-2" data-id="element-2294">•</span>
                    <span data-id="element-2295">
                      <span className="font-semibold" data-id="element-2296">91%</span> achieved clear
                      test results by week 4
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-2297">
                    <span className="text-rose-600 font-semibold mr-2" data-id="element-2298">•</span>
                    <span data-id="element-2299">
                      <span className="font-semibold" data-id="element-2300">89%</span> remained
                      completely symptom-free at 6-month follow-up
                    </span>
                  </li>
                </ul>
                <div className="mt-4 pt-3 border-t border-rose-100" data-id="element-2301">
                  <Link to="/adv-1" className="text-rose-700 font-medium hover:text-rose-800 flex items-center" data-id="element-2302">
                    Read the full research
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor" data-id="element-2303">
                      <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" data-id="element-2304" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Menopause Solution */}
        <div className="bg-white p-6 border-l-4 border-amber-500 shadow-sm" data-id="element-2305">
          <div className="flex items-start" data-id="element-2306">
            <HeartIcon className="h-6 w-6 text-amber-500 mr-4 mt-1 flex-shrink-0" data-id="element-2307" />
            <div data-id="element-2308">
              <h3 className="text-xl font-serif font-semibold text-slate-900 mb-3" data-id="element-2309">
                Comprehensive Menopause Relief Protocol
              </h3>
              <p className="text-base text-slate-700 leading-relaxed mb-4" data-id="element-2310">
                Our proprietary phytoestrogen complex has been shown to reduce
                hot flash frequency and severity without the risks associated
                with traditional hormone replacement therapy.
              </p>
              <div className="bg-amber-50 p-4 rounded" data-id="element-2311">
                <p className="text-slate-800 font-medium" data-id="element-2312">Clinical Results:</p>
                <ul className="mt-2 space-y-2" data-id="element-2313">
                  <li className="flex items-start" data-id="element-2314">
                    <span className="text-amber-600 font-semibold mr-2" data-id="element-2315">•</span>
                    <span className="bg-yellow-100 px-1" data-id="element-2316">
                      <span className="font-semibold" data-id="element-2317">83%</span> of women
                      experienced reduced hot flash frequency within 21 days
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-2318">
                    <span className="text-amber-600 font-semibold mr-2" data-id="element-2319">•</span>
                    <span data-id="element-2320">
                      <span className="font-semibold" data-id="element-2321">76%</span> reported
                      improved mood stability and reduced irritability
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-2322">
                    <span className="text-amber-600 font-semibold mr-2" data-id="element-2323">•</span>
                    <span data-id="element-2324">
                      Average{' '}
                      <span className="font-semibold" data-id="element-2325">68% decrease</span> in
                      night sweats after 30 days
                    </span>
                  </li>
                </ul>
                <div className="mt-4 pt-3 border-t border-amber-100" data-id="element-2326">
                  <a href="#" className="text-amber-700 font-medium hover:text-amber-800 flex items-center" data-id="element-2327">
                    Learn more about our menopause solutions
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor" data-id="element-2328">
                      <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" data-id="element-2329" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Brain Health Solution */}
        <div className="bg-white p-6 border-l-4 border-indigo-500 shadow-sm" data-id="element-2330">
          <div className="flex items-start" data-id="element-2331">
            <BrainIcon className="h-6 w-6 text-indigo-500 mr-4 mt-1 flex-shrink-0" data-id="element-2332" />
            <div data-id="element-2333">
              <h3 className="text-xl font-serif font-semibold text-slate-900 mb-3" data-id="element-2334">
                Neurologist-Backed Approach to Brain Fog & Cognitive Changes
              </h3>
              <p className="text-base text-slate-700 leading-relaxed mb-4" data-id="element-2335">
                Our proprietary blend of neuroprotective compounds addresses the
                hormonal changes that affect cognitive function during
                perimenopause and menopause.
              </p>
              <div className="bg-indigo-50 p-4 rounded" data-id="element-2336">
                <p className="text-slate-800 font-medium" data-id="element-2337">Clinical Results:</p>
                <ul className="mt-2 space-y-2" data-id="element-2338">
                  <li className="flex items-start" data-id="element-2339">
                    <span className="text-indigo-600 font-semibold mr-2" data-id="element-2340">
                      •
                    </span>
                    <span className="bg-yellow-100 px-1" data-id="element-2341">
                      Cognitive performance scores improved by{' '}
                      <span className="font-semibold" data-id="element-2342">38%</span> in our 6-week
                      trial
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-2343">
                    <span className="text-indigo-600 font-semibold mr-2" data-id="element-2344">
                      •
                    </span>
                    <span data-id="element-2345">
                      <span className="font-semibold" data-id="element-2346">79%</span> of participants
                      reported improved mental clarity and focus
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-2347">
                    <span className="text-indigo-600 font-semibold mr-2" data-id="element-2348">
                      •
                    </span>
                    <span data-id="element-2349">
                      Working memory capacity increased by{' '}
                      <span className="font-semibold" data-id="element-2350">42%</span> on standardized
                      tests
                    </span>
                  </li>
                </ul>
                <div className="mt-4 pt-3 border-t border-indigo-100" data-id="element-2351">
                  <a href="#" className="text-indigo-700 font-medium hover:text-indigo-800 flex items-center" data-id="element-2352">
                    Discover the protocol
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor" data-id="element-2353">
                      <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" data-id="element-2354" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};